export enum AiSummaryReviewRating {
  POSITIVE = 1,
  NEGATIVE = 2,
}
